export const NOTI_SISTEMA = 1;